module.exports = __webpack_public_path__ + "static/media/storage.d6a8dfd0.mp4";